export const KeywordConstant = {
  MIN_KEYWORD: 1,
  MIN_CHAR_IN_KEYWORD: 3,
  DELAY_IN_KEYWORD_SUGGEST_API_CALL: 5,
};
export const GEV_ID_LABEL = "GEV ID";
export const barCodeTypes = [`${GEV_ID_LABEL} Tag`, "BOL Tag", "Serial NO #"];
export const QuestionDeleteMsg =
  "Are you sure you want to delete this question?";
export const SectionDeleteMsg = "Are you sure you want to delete this section?";
export const SubsectionDeleteMsg =
  "Are you sure you want to delete this subsection?";
export const debugState = false;

export const roles = [
  { roleId: "GLOBALADMIN", roleName: "Global Admin" },
  { roleId: "SITEMANAGER", roleName: "Site Manager" },
  { roleId: "TECHNICIAN", roleName: "Technician" },
  { roleId: "ASSETMANAGER", roleName: "Asset Manager" },
  { roleId: "FORMAUTHOR", roleName: "Form Author" },
];
export const userObject = {
  sub: "223031958",
  firstname: "Ramanathan",
  lastname: "Murugesan ",
  mail: "Farija.Parveen@ge.com",
  userRole: "GLOBALADMIN",
  title: "DT Services - Author",
  employeetype: "Contractor",
  gehrbusinesssegment: "Renewable Energy COEs",
  gessobusinessunit: "REN COES-Digital Technology",
  gessouid: "21E31968-34D2-1F06-B460-002128B20D70",
};
export const AccessToken = {
  role: {
    ASSETMANAGER: "ASSETMANAGER",
    GLOBALADMIN: "GLOBALADMIN",
    SITEMANAGER: "SITEMANAGER",
    TECHNICIAN: "TECHNICIAN",
    FORMAUTHOR: "FORMAUTHOR",
  },
  scope: {
    ASSETMANAGER: "fwapi/fw_write_access",
    GLOBALADMIN: "fwapi/fw_admin_access",
    SITEMANAGER: "fwapi/fw_write_access",
    TECHNICIAN: "fwapi/fw_read_access",
    FORMAUTHOR: "fwapi/fw_admin_access",
  },
};
export const messages = {
  CANNOT_UPLOAD_MORE_IMAGES: "User can upload only 3 files.!",
  IMAGE_UPLOADED_MESSAGE: "Image uploaded successfully.!",
  IMAGE_DELETED_MESSAGE: "Image deleted successfully.!",
  ERROR_MESSAGE: "Could not able to perform action due to ",
  LOREM_IPSUM:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, " +
    "sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  FILE_SIZE_ERROR: "File size exceeds 5 MB. Please upload a smaller file.",
  UPLOAD_HINT: "* Supported file formats: PNG, JPEG, PDF, MP4. Maximum upload size: 5 MB.",
};
export const GeneralConfig = {
  MAX_IMAGE_COUNT: 3,
  MAX_FILE_SIZE_BYTES: 5 * 1024 * 1024,
  DELETE: "DELETE",
  GET: "GET",
  UPLOAD: "UPLOAD",
};
export const SUB_SECTION = "subsection";
export const SECTION = "section";
export const YES = "YES";
export const NO = "NO";
export const SELECT_TYPE = "Select Type";
export const REVIEW_PAGE_MAX_PDF_SIZE = 50;
export const OTHERS = "Others";
export const EMPTY_STRING = "";

export const CACHE_KEY = {
  REGIONS: "regions",
  SITES: "sites",
  ALL_SITES: "all-sites",
  TURBINES: "turbines",
  LANGUAGES: "languages",
  CATEGORIES: "categories",
  USER_GROUPS: "user-groups",
  OPTIONAL_EQUIPMENTS: "optional-equipments",
  FORM_TEMPLATES: "form-templates",
};

export const SORT_KEY = {
  NAME: "name",
};

export const CONDITIONAL_FORM = {
  CONDITIONAL: "Conditional",
  UNIVERSAL_TAGGING_SPLIT: "~",
  ZERO_LEVEL: 0,
  FIRST_LEVEL: 1,
  MAX_LEVEL: 4,
  ALL: "all",
  RECEIVING: "Receiving",
};

export const GE_ID_TAG_PROPERTIES = {
  GE_ID_TAG: "geIdTag",
  STATUS: "status",
  MANUFACTURER_NAME: "manufacturerName",
  LOADER: "loader",
  INITIAL_GE_ID_TAG: "initialGeIdTag",
  GE_ID: "GE_ID",
};

export const GE_ID_TAG_STATUS = {
  VALID: "VALID",
  INVALID: "INVALID",
  EMPTY_STRING: "",
};

export const DPRO_STATUS = {
  SUCCESS: "SUCCESS",
  FAILED: "FAILED",
  NEW: "NEW",
};

export const GE_ID_KEYS = {
  STATUS: "Status",
  TAG_DETAILS: "TagDetails",
  VENDOR_NAME: "Vendor Name",
};

export const IS_CONDITIONAL_FORM_ENABLED =
  process.env.REACT_APP_ENABLE_CONDITIONAL_FORM === "true";

export const IS_LINK_PROMPT_ENABLED =
  process.env.REACT_APP_ENABLE_LINK_PROMPT === "true";

export const COMPONENT_TYPE = {
  INPUT_TEXT: "text",
  TEXTAREA: "textarea",
  RADIO_BUTTON: "radio",
  CHECKBOX: "checkbox",
  DROPDOWN: "select",
  DATE_TIME: "date",
  RANGE_SLIDER: "range",
  FILE_UPLOADER: "fileInput",
  DEPENDENT_DROPDOWN: "dependentDropdown",
  BARCODE_SCANNER: "barcode",
  SIGNATURE: "signature",
  INSTRUCTION_HELP: "helpimage",
};
